import { CreativeTagEvent, CreativeTagTracking } from '../enums';

export const eventByTrackingMap = new Map<
  CreativeTagEvent,
  CreativeTagTracking
>([
  [CreativeTagEvent.CREATIVE_INIT, CreativeTagTracking.INIT],
  [CreativeTagEvent.CREATIVE_REQUESTED, CreativeTagTracking.REQUEST],
  [CreativeTagEvent.CREATIVE_ASSET_LOAD, CreativeTagTracking.LOAD],
  [CreativeTagEvent.CREATIVE_LOADED, CreativeTagTracking.INSTALLED],
  [CreativeTagEvent.CREATIVE_LOADING_FAILED, CreativeTagTracking.FAIL],
  [CreativeTagEvent.CREATIVE_DISPLAY, CreativeTagTracking.DISPLAY],
  [CreativeTagEvent.CREATIVE_VIEW, CreativeTagTracking.VIEW],
  [CreativeTagEvent.CREATIVE_TIMESPENT, CreativeTagTracking.TIMESPENT],
  [CreativeTagEvent.CREATIVE_SHOW, CreativeTagTracking.SHOW],
  [CreativeTagEvent.CREATIVE_CLICKED, CreativeTagTracking.CLICK]
]);
